import { render, staticRenderFns } from "./BoxArrowUpRight.vue?vue&type=template&id=6d056719"
import script from "./BoxArrowUpRight.vue?vue&type=script&lang=js"
export * from "./BoxArrowUpRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports